import { render, staticRenderFns } from "./CookiesWidget.vue?vue&type=template&id=5159c776&"
import script from "./CookiesWidget.vue?vue&type=script&lang=js&"
export * from "./CookiesWidget.vue?vue&type=script&lang=js&"
import style0 from "./CookiesWidget.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports